import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import {
  beginHistoryTransaction,
  cancelHistoryTransaction,
  commitHistoryTransaction,
} from "../app/slices/HistorySlice";
import { deleteKeys } from "../app/slices/TrainingLocalizationSlice";
import { deleteTake } from "../app/slices/TrainingSlice";
import { removeWarningsAndErrorsForInteractions } from "../app/slices/ValidationSlice";
import { collectTakeDeletionCleanup } from "../helpers/TakeDeletionHelper";
import Take from "../models/Take";

export function useDeleteTakeWithCleanup() {
  const dispatch = useDispatch();

  const deleteTakeWithCleanup = useCallback(
    (take: Take) => {
      const { localizationKeys, validationInteractionIds } =
        collectTakeDeletionCleanup(take);
      const transaction = { id: `delete-take-${uuidv4()}` };

      dispatch(beginHistoryTransaction(transaction));
      try {
        dispatch(deleteTake(take.id));
        dispatch(deleteKeys(localizationKeys));
        dispatch(
          removeWarningsAndErrorsForInteractions({
            interactionIds: validationInteractionIds,
          }),
        );
        dispatch(commitHistoryTransaction(transaction));
      } catch (error) {
        dispatch(cancelHistoryTransaction(transaction));
        throw error;
      }
    },
    [dispatch],
  );

  return { deleteTakeWithCleanup } as const;
}
